import { Match, Switch } from "solid-js";
import type { EditableOnboardingStep } from "../utils/review-edit";
import { Education } from "./steps/Education";
import { Experience } from "./steps/Experience";
import { Info } from "./steps/Info";
import { JobTitle } from "./steps/JobTitle";
import { Locale } from "./steps/Locale";
import { OnlinePrecense } from "./steps/OnlinePrecense";
import { Pricing } from "./steps/Pricing";
import { Sector } from "./steps/Sector";
import { Skills } from "./steps/Skills";
import { Summary } from "./steps/Summary";

/**
 * Renders a single onboarding step component inline within the review screen,
 * driven by the `?edit=<step>` query param. Mirrors the step→component mapping
 * in `ManualOnboarding`, minus `source` and `review` (which are not editable).
 */
export const EditStepView = (props: {
  step: EditableOnboardingStep;
  /** Pixels of the scroll area under the fixed bar, for the sector step. */
  bottomInset?: number;
}) => {
  return (
    <Switch>
      <Match when={props.step === "sector"}>
        <Sector bottomInset={props.bottomInset} />
      </Match>
      <Match when={props.step === "skills"}>
        <Skills />
      </Match>
      <Match when={props.step === "job_title"}>
        <JobTitle />
      </Match>
      <Match when={props.step === "experience"}>
        <Experience />
      </Match>
      <Match when={props.step === "education"}>
        <Education />
      </Match>
      <Match when={props.step === "locale"}>
        <Locale />
      </Match>
      <Match when={props.step === "summary"}>
        <Summary />
      </Match>
      <Match when={props.step === "pricing"}>
        <Pricing />
      </Match>
      <Match when={props.step === "info"}>
        <Info />
      </Match>
      <Match when={props.step === "online-presence"}>
        <OnlinePrecense />
      </Match>
    </Switch>
  );
};
